export enum LoonAction {
	VIEW = "view",
	EDIT = "edit",
	NEW = "new",
	ADD = "add",
}
